export type DrawingMode = 'none' | 'marker' | 'polyline' | 'polygon' | 'circle';

interface DrawingToolsProps {
  onModeChange: (mode: DrawingMode) => void;
  activeMode: DrawingMode;
  onClearAll?: () => void;
  drawingCount?: number;
}

const DrawingTools = ({ onModeChange, activeMode, onClearAll, drawingCount = 0 }: DrawingToolsProps) => {
  const tools = [
    { mode: 'marker' as DrawingMode, icon: '📍', label: 'Add Marker' },
    { mode: 'polyline' as DrawingMode, icon: '📏', label: 'Draw Line' },
    { mode: 'polygon' as DrawingMode, icon: '⬟', label: 'Draw Polygon' },
    { mode: 'circle' as DrawingMode, icon: '⭕', label: 'Draw Circle' },
  ];

  return (
    <div className="drawing-tools">
      {tools.map((tool) => (
        <button
          key={tool.mode}
          className={`tool-button ${activeMode === tool.mode ? 'active' : ''}`}
          onClick={() => onModeChange(activeMode === tool.mode ? 'none' : tool.mode)}
          title={tool.label}
        >
          <span className="tool-icon">{tool.icon}</span>
          <span>{tool.label}</span>
        </button>
      ))}
      {onClearAll && drawingCount > 0 && (
        <button
          className="tool-button clear-button"
          onClick={onClearAll}
          title={`Clear all ${drawingCount} drawing(s)`}
        >
          <span className="tool-icon">🗑️</span>
          <span>Clear All ({drawingCount})</span>
        </button>
      )}
    </div>
  );
};

export default DrawingTools;
